
<div class="chart m_t_20 m_b_20 multi_opt p_l_r_16">
  <div class="graph_heading">Vibration Trend <span class="unit">(m/sec<sup>2</sup>)</span></div>
  <div class="flex">
    <div class="flex-item">
      <div class="Acceleromgraph_outer">
        <div id="dashboard_div">
          <div id='chart_div' style="width:100%;max-width: 100%"></div>
          <div id="control_div" style="height:40px">
          </div>
        </div>
      </div>
      <div class="Acceleromgraph_outer no_data_div" style="display: block;height: 50px;" *ngIf="!showlineChart1">
        <div class="text-center x_axis_div">No Data Found</div>
      </div>
    </div>
  </div>
</div>


<div class="chart m_b_20 multi_opt p_l_r_16 ">
  <div class="graph_heading">Temperature Trend <span class="unit">(℃)</span></div>
  <div class="flex">
    <div class="flex-item">
      <div class="Tempgraph_outer">
        <!--<div class="y_axis_div">
    Temperature(°C)
  </div>-->
        <div id="dashboard_div_temp">
          <div id='chart_div_temp' style="width:100%;max-width: 100%"></div>
          <div id="control_div_temp" style="height:40px">
            <!-- Controls renders here -->
          </div>
        </div>

        <!--<canvas baseChart height="100" [datasets]="lineChartDataTemp" [labels]="lineChartLabelsTemp"
    [options]="lineChartOptionsTemp" [colors]="lineChartColors" [legend]="lineChartLegend"
    [chartType]="lineChartType" [plugins]="lineChartPlugins"></canvas>-->
        <!--<div class="text-center x_axis_div">
    Time(HH:MM)
  </div>-->
      </div>
      <div class="Tempgraph_outer no_data_div" style="display: block;height: 50px;" *ngIf="!showlineChart2">
        <div class="text-center x_axis_div">No Data Found</div>
      </div>
    </div>
  </div>
</div>


<div class="chart multi_opt m_b_150 p_l_r_16">
  <div class="graph_heading">Orientation <span class="unit">(Degrees)</span></div>
  <div class="flex">
    <div class="flex-item">
      <div class="Tempgraph_outer2">
        <div id="dashboard_div_orientation">
          <div id='chart_div_orientation' style="width:100%;max-width: 100%"></div>
          <div id="control_div_orientation" style="height:40px"></div>
        </div>
      </div>
      <div class="Tempgraph_outer no_data_div" style="display: block;height: 50px;" *ngIf="!showlineChart3">
        <div class="text-center x_axis_div">No Data Found</div>
      </div>
    </div>
  </div>
</div>